import React from "react";
import styled from "@emotion/styled";
import HeroSection from "../../Components/Sections/S1-Hero";
import bg from "../../../assets/images/background.jpg"
import PSBG from "../../../assets/images/PSBG.png"
import { Container } from "@mui/material";
const ContainerWraper = styled(Container)`
  background-Image: url(${bg});
  background-size: cover;
  background-position: center;
  background-repeat:no-repeat;
  width: 100%;
  height: 100vh;
  padding: 0 !important;
  @media(max-width: 599px){
  background-Image: url(${PSBG});
  background-size: cover;
  background-position: center;
  background-repeat:no-repeat;
  }
`;


const MainPage = () => {
  
  return (
    <>
      
        <ContainerWraper maxWidth="xxl">
          <Container>
        <HeroSection />
          </Container>
        </ContainerWraper>
    </>
  );
};

export default MainPage;
